import { render, staticRenderFns } from "./koiRaffle.vue?vue&type=template&id=4dcdf2a9&scoped=true"
import script from "./koiRaffle.vue?vue&type=script&lang=ts"
export * from "./koiRaffle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcdf2a9",
  null
  
)

export default component.exports